import { createFileRoute } from "@tanstack/react-router";
import EmailPreview from "@/pages/EmailPreview";

export const Route = createFileRoute("/email-preview")({
  head: () => ({
    meta: [
      { title: "E-mailvoorbeeld | De Hussel App" },
      { name: "description", content: "Interne preview van e-mailtemplates." },
      { property: "og:title", content: "E-mailvoorbeeld | De Hussel App" },
      { property: "og:description", content: "Interne preview van e-mailtemplates." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EmailPreview,
});
